import { pageGraph, orgGraph, toJson, abs, clean, DEFAULT_SITE } from "./schema";
import { FAQS } from "./routing";

export const SITE = clean(process.env.REACT_APP_SITE_URL || DEFAULT_SITE);

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}
function setLd(id, obj) {
  let el = document.getElementById(id);
  if (!el) { el = document.createElement("script"); el.type = "application/ld+json"; el.id = id; document.head.appendChild(el); }
  el.textContent = toJson(obj);
}

/* Keeps <head> in sync with the current route (client-side navigation). */
export function applySeo(route) {
  const url = abs(SITE, route.canonical || route.path);
  document.title = route.title;
  setMeta("name", "description", route.description);
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
  link.href = url;
  setMeta("property", "og:title", route.title);
  setMeta("property", "og:description", route.description);
  setMeta("property", "og:url", url);
  setMeta("name", "twitter:title", route.title);
  setMeta("name", "twitter:description", route.description);
  setLd("ld-org", orgGraph(SITE));
  setLd("ld-page", pageGraph(SITE, route, route.faq ? FAQS[route.faq] : null));
}
